import React, { useState, useEffect } from "react";

function FoodSearch() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [error, setError] = useState("");
  const [log, setLog] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [savedRecipes, setSavedRecipes] = useState([]);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("savedRecipes")) || [];
    setSavedRecipes(saved);
  }, []);

  const handleSearch = async () => {
    if (!query) return;
    setLoading(true);
    setError("");
    setResults([]);
    try {
      const res = await fetch(
        `https://world.openfoodfacts.org/cgi/search.pl?search_terms=${encodeURIComponent(
          query
        )}&search_simple=1&action=process&json=1`
      );

      const data = await res.json();

      if (data.products && data.products.length > 0) {
        setResults(data.products.slice(0, 5));
      } else {
        setError("No results found.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const addToLog = (item) => {
    setLog([...log, item]);
    setMessage(`${item.product_name || "Item"} added to log.`);
    setTimeout(() => setMessage(""), 2000);
  };

  const removeFromLog = (index) => {
    const updatedLog = [...log];
    updatedLog.splice(index, 1);
    setLog(updatedLog);
  };

  const getTotal = (key) => {
    const logTotal = log.reduce((total, item) => {
      const value = parseFloat(item.nutriments[key]);
      return total + (isNaN(value) ? 0 : value);
    }, 0);

    const recipeTotal = savedRecipes.reduce((total, recipe) => {
      return total + parseFloat(recipe.totals[key] || 0);
    }, 0);

    return (logTotal + recipeTotal).toFixed(1);
  };

  return (
    <div className="food-search">
      <h2>🔍 Search Food</h2>

      <div className="search-bar">
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Enter food name..."
        />
        <button onClick={handleSearch}>Search</button>
      </div>

      {loading && <p>Searching...</p>}
      {message && <p style={{ color: "green" }}>{message}</p>}
      {error && <p className="error">{error}</p>}

      <div className="results-grid">
        {results.map((item, index) => (
          <div key={index} className="food-card">
            {item.image_url && (
              <img
                src={item.image_url}
                alt={item.product_name}
                style={{
                  width: "100%",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginBottom: "10px",
                }}
              />
            )}
            <strong>{item.product_name || "Unnamed Item"}</strong>
            <p>🔥 Calories: {item.nutriments["energy-kcal"] || "N/A"} kcal</p>
            <p>💪 Protein: {item.nutriments.proteins || "N/A"} g</p>
            <p>🧈 Fat: {item.nutriments.fat || "N/A"} g</p>
            <p>🍞 Carbs: {item.nutriments.carbohydrates || "N/A"} g</p>
            <button onClick={() => addToLog(item)}>➕ Add to Log</button>
          </div>
        ))}
      </div>

      <hr />

      <h3>📋 Today's Log</h3>
      <ul>
        {log.map((item, index) => (
          <li key={index}>
            {item.product_name || "Unnamed"} — {item.nutriments["energy-kcal"] || "?"} kcal
            <button onClick={() => removeFromLog(index)} style={{ marginLeft: "10px" }}>
              ❌ Remove
            </button>
          </li>
        ))}
        {savedRecipes.map((recipe, index) => (
          <li key={`recipe-${index}`}>
            <strong>{recipe.name}</strong> — {recipe.totals.calories} kcal
          </li>
        ))}
      </ul>

      {(log.length > 0 || savedRecipes.length > 0) && (
        <div style={{ marginTop: "10px" }}>
          <strong>Nutrition Totals:</strong>
          <br />
          Calories: {getTotal("energy-kcal") || getTotal("calories")} kcal
          <br />
          Protein: {getTotal("proteins") || getTotal("protein")} g
          <br />
          Fat: {getTotal("fat")} g
          <br />
          Carbs: {getTotal("carbohydrates") || getTotal("carbs")} g
        </div>
      )}
    </div>
  );
}

export default FoodSearch;
